import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const LegalPagesHub = () => {
  const navigate = useNavigate();

  const pages = [
    {
      title: 'Terms of Service',
      description: 'Rules and conditions for using FireCaseIQ.',
      path: '/terms-of-service',
      icon: 'FileText',
    },
    {
      title: 'Privacy Policy',
      description: 'How we collect, use, and protect your information.',
      path: '/privacy-policy',
      icon: 'Shield',
    },
    {
      title: 'Refund Policy',
      description: 'Refund eligibility and how refunds are processed.',
      path: '/refund-policy',
      icon: 'Receipt',
    },
    {
      title: 'Report Disclaimer',
      description: 'AI-generated outputs are preliminary and informational.',
      path: '/report-disclaimer',
      icon: 'AlertTriangle',
    },
  ];

  return (
    <div className="min-h-screen bg-background">
      <header className="bg-card border-b border-border py-4">
        <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8 flex items-center justify-between">
          <button
            onClick={() => navigate('/')}
            className="flex items-center"
          >
            <img src="/assets/images/logo.png" alt="FireCaseIQ" className="h-10 object-contain" />
          </button>

          <Button variant="outline" onClick={() => navigate(-1)} iconName="ArrowLeft">
            Back
          </Button>
        </div>
      </header>

      <main className="py-12">
        <div className="max-w-5xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-foreground">Legal</h1>
            <p className="text-sm text-muted-foreground mt-2">
              Select a document below.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {pages.map((p) => (
              <button
                key={p.path}
                onClick={() => navigate(p.path)}
                className="text-left bg-card border border-border rounded-lg p-6 hover:shadow-md transition-smooth"
              >
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center">
                    <Icon name={p.icon} size={20} className="text-foreground" />
                  </div>
                  <div className="flex-1">
                    <h2 className="text-lg font-semibold text-foreground">{p.title}</h2>
                    <p className="text-sm text-muted-foreground mt-1">{p.description}</p>
                    <div className="mt-4 inline-flex items-center gap-2 text-sm text-primary">
                      Open <Icon name="ArrowRight" size={16} />
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>

          <div className="mt-10 text-xs text-muted-foreground">
            AI-generated outputs are preliminary and informational. Not legal advice. Not a substitute
            for a licensed on-site investigation.
          </div>
        </div>
      </main>
    </div>
  );
};

export default LegalPagesHub;
